// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Hie4G","container":"styles_container__k2qPT","wallet":"styles_wallet__QblVw","wallet_list":"styles_wallet_list__sBc-L","link":"styles_link__2VToa"};